import { render, staticRenderFns } from "./onlineStudy.vue?vue&type=template&id=0b89f5e8&scoped=true"
import script from "./onlineStudy.vue?vue&type=script&lang=js"
export * from "./onlineStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89f5e8",
  null
  
)

export default component.exports